import * as React from 'react';
import { formField, IformField } from 'framework/components/hoc/formField';
import { Multiselect } from './Multiselect';
import { IMultiSelect } from './Multiselect.interfaces';

export default formField(Multiselect) as any as React.StatelessComponent<IMultiSelect & IformField>;
